import { configureStore, ThunkAction, Action } from '@reduxjs/toolkit';
import { useRef } from 'react';
import { createCompanyLineReducer } from './companyLine/reducer';
import { createTimetableReducer } from './timetable/reducer';

export const store = configureStore({
  reducer: {
    companyLine: createCompanyLineReducer,
    timetable: createTimetableReducer
  },
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;

export function useAction<TAction>(action: TAction): TAction
export function useAction(action: any): any {
    return useRef(action).current;
}